import React from 'react'
import Image from 'marketing-site/src/components/common/NextImageWrapper'
import { IProps } from './index'
import { mq } from 'marketing-site/src/library/utils'
import { Text } from 'marketing-site/src/library/elements/Text'

export const StaticCard = ({ image, title, subhead, textAlignment = 'start' }: IProps) => {
  const imageSizes = {
    tablet: { width: 392, height: 261 },
  }
  return (
    <div className="static-card">
      <div className="static-card__image">
        <Image
          src={image.url}
          width={335}
          height={223}
          layout={'responsive'}
          alt={image.altText}
          quality={100}
          sizes={`(${mq.tablet}) ${imageSizes.tablet.width}px, ${imageSizes.tablet.height}px`}
          priority={true}
        />
      </div>
      {title && (
        <div className="static-card__title">
          <Text size="heading-4">{title}</Text>
        </div>
      )}
      {subhead && (
        <div className="static-card__subhead">
          <Text size="body">{subhead}</Text>
        </div>
      )}
      <style jsx>{`
        .static-card {
          max-width: 21rem;
          display: flex;
          flex-direction: column;
          margin: 0 auto;
          text-align: ${textAlignment};

          &__image {
            border-radius: 1rem;
            overflow: hidden;
          }

          &__title {
            margin: 1.5rem 0.5rem 0 0.5rem;
          }

          &__subhead {
            margin: 0.5rem 0.5rem 0 0.5rem;
          }
        }

        @media (${mq.tablet}) {
          .static-card {
            max-width: 24.5rem;

            &__image {
              border-radius: 1.5rem;
            }
            &__title {
              margin: 2rem 0.5rem 0 0.5rem;
            }

            &__subhead {
              margin: 0.75rem 0.5rem 0 0.5rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
